module.exports = __webpack_public_path__ + "img/img4.edc4773b.jpg";